import { ImageLoaderProps } from "next/image";

const imageLoader = ({ src, width = 0, quality = 75 }: ImageLoaderProps) => {
  return `${src}/m/${width}x0/filters:quality(${quality})`;
};

export default imageLoader;
